<template>
  <div>
    <div class="d-flex flex-wrap" style="max-width: 580px">
      <v-text-field
        v-model="search"
        class="fix-google-chrome mr-2"
        label="รหัส - ชื่อพนักงาน"
        prepend-inner-icon="mdi-magnify"
        clearable
        outlined
        dense
        hide-details
        @input="handleSearch"
      ></v-text-field>
      <v-autocomplete
        v-model="filterOrganization"
        class="fix-google-chrome"
        label="หน่วยงาน"
        :items="organizations"
        item-text="title_th"
        item-value="organization_uuid"
        outlined
        dense
        hide-details
        clearable
        @change="handleFilterOrganization"
        :loading="loadingFilterOrganization"
      >
      </v-autocomplete>
      <v-btn class="ml-2" icon :loading="loading" @click="handleRefresh">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </div>
    <v-data-table
      class="mt-4 with-borders"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      :headers="headers"
      :items="flattenedRows"
      :options.sync="optionsEmployee"
      :server-items-length="authorityEmployeeInAuthority.total"
      :items-per-page="10"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      must-sort
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-if="!items.length">
            <td style="text-align: center" colspan="4">No data available</td>
          </tr>
          <tr v-for="(item, index) in items" :key="index">
            <!-- Employee -->
            <td
              :style="`vertical-align: ${
                item.employeeRowSpan > 1 ? 'top' : 'middle'
              }; padding: 10px 15px`"
              v-if="item.showEmployee"
              :rowspan="item.employeeRowSpan"
            >
              <div class="d-flex justify-space-between align-center">
                <div>
                  <div>{{ item.employeeName }} ({{ item.employeeCode }})</div>
                  <div class="grey--text caption">
                    {{ item.organizationName }}
                  </div>
                </div>
                <div v-if="getEmployeeSyncBlockReason(item.employeeStatus)">
                  <v-btn
                    icon
                    color="warning"
                    small
                    @click="onShowEmployeeStatus(item.employeeStatus)"
                  >
                    <v-icon>mdi-alert</v-icon>
                  </v-btn>
                </div>
              </div>
            </td>

            <!-- Authority -->
            <td>
              <div class="d-flex justify-space-between align-center">
                <div>
                  <div>{{ item.authority }}</div>
                  <div class="caption grey--text">
                    <span v-if="item.accessControlStartTime">
                      {{ item.accessControlStartTime }}
                    </span>
                    <span v-if="item.accessControlEndTime">
                      {{ `- ${item.accessControlEndTime}` }}
                    </span>
                  </div>
                </div>
                <div>
                  <v-btn
                    text
                    color="error"
                    @click.stop="onDeleteEmployee(item)"
                    :disabled="
                      uiCtrl &&
                      !uiCtrl.isEnable('btn:::authority_hardware:delete')
                    "
                    >ลบ</v-btn
                  >
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <ConfirmDialog
      :dialog="confirmDeleteEmployee"
      :loading="confirmDeleteEmployeeLoading"
      :dialogData="confirmDeleteEmployeeData"
      @cancelConfirmDialog="cancelConfirmDeleteEmployee"
      @submitConfirmDialog="submitConfirmDeleteEmployee"
    />
    <v-dialog v-model="employeeStatusDialog" width="500">
      <v-card v-if="selectedEmployeeStatus">
        <v-card-title class="body-2 grey lighten-2">
          <div class="d-flex align-center">
            <v-icon class="mr-2" color="warning">mdi-alert</v-icon>
            <div>รายละเอียดสถานะพนักงาน</div>
          </div>
        </v-card-title>
        <v-card-text class="py-4">
          <div class="mb-3">
            <div class="caption grey--text">ชื่อพนักงาน</div>
            <div class="body-2 font-weight-medium">
              {{ selectedEmployeeStatus.firstname_th }}
              {{ selectedEmployeeStatus.lastname_th }}
              ({{ selectedEmployeeStatus.employee_code }})
            </div>
          </div>
          <div class="mb-3">
            <div class="caption grey--text">หน่วยงาน</div>
            <div class="body-2">
              {{
                selectedEmployeeStatus.organization
                  ? selectedEmployeeStatus.organization.title_th
                  : '-'
              }}
            </div>
          </div>
          <v-divider class="my-3"></v-divider>
          <div class="mb-3">
            <div class="caption grey--text">สถานะการใช้งาน</div>
            <div
              class="body-2"
              :style="{ color: '#d32f2f', fontWeight: 'bold' }"
            >
              {{ getEmployeeSyncBlockReason(selectedEmployeeStatus) }}
            </div>
          </div>
          <div class="mb-3" v-if="selectedEmployeeStatus.resign_date">
            <div class="caption grey--text">วันที่ลาออก</div>
            <div class="body-2">{{ selectedEmployeeStatus.resign_date }}</div>
          </div>
          <div
            class="mb-3"
            v-if="
              selectedEmployeeStatus.time_attendance_start_time &&
              !getEmployeeSyncBlockReason(selectedEmployeeStatus)?.includes(
                'หมดอายุ'
              )
            "
          >
            <div class="caption grey--text">วันเวลาเริ่มต้น</div>
            <div class="body-2">
              {{
                formatDateTime(
                  selectedEmployeeStatus.time_attendance_start_time
                )
              }}
            </div>
          </div>
          <div
            class="mb-3"
            v-if="selectedEmployeeStatus.time_attendance_end_time"
          >
            <div class="caption grey--text">วันเวลาสิ้นสุด</div>
            <div class="body-2">
              {{
                formatDateTime(selectedEmployeeStatus.time_attendance_end_time)
              }}
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed @click="employeeStatusDialog = false"> ปิด </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    dialogCheckPermissions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: '',
      filterOrganization: null,
      sortBy: ['employeeCode'],
      sortDesc: [false],
      loading: false,
      loadingFilterOrganization: false,
      headers: [
        {
          text: 'พนักงาน',
          align: 'start',
          value: 'employeeCode',
          width: '25%',
        },
        {
          text: 'กลุ่มสิทธิ์',
          value: 'authority',
          width: '75%',
          sortable: false,
        },
      ],
      optionsEmployee: {},
      confirmDeleteEmployee: false,
      confirmDeleteEmployeeLoading: false,
      confirmDeleteEmployeeData: {},
      employeeStatusDialog: false,
      selectedEmployeeStatus: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    organizations() {
      return this.$store.state.organization.organizations
    },
    authorityEmployeeInAuthority() {
      return this.$store.state.accessAuthority.authorityEmployeeInAuthority
    },
    flattenedRows() {
      const result = []
      const employees = this.authorityEmployeeInAuthority.employees || []

      employees.forEach((employee) => {
        const employee_uuid = employee.employee_uuid
        const employeeCode = employee.employee_code
        const employeeName = `${employee.firstname_th} ${employee.lastname_th}`
        const organizationName = employee.organization?.title_th || ''

        const authorities = employee.authorities || []
        const employeeRowSpan = authorities.length || 1

        if (authorities.length === 0) {
          result.push({
            employee_uuid,
            employeeCode,
            employeeName,
            organizationName,
            employeeStatus: employee,
            showEmployee: true,
            employeeRowSpan: 1,
            authority: '',
            authority_uuid: null,
            accessControlStartTime: '',
            accessControlEndTime: '',
          })
          return
        }

        authorities.forEach((auth, authIndex) => {
          result.push({
            employee_uuid,
            employeeCode,
            employeeName,
            organizationName,
            employeeStatus: employee,
            showEmployee: authIndex === 0,
            employeeRowSpan: authIndex === 0 ? employeeRowSpan : 0,
            authority: `${auth.authority_code} - ${auth.title_th}`,
            authority_uuid: auth.authority_uuid,
            accessControlStartTime: auth.access_control_start_time
              ? moment
                  .utc(auth.access_control_start_time)
                  .format('DD/MM/YYYY HH:mm')
              : '',
            accessControlEndTime: auth.access_control_end_time
              ? moment
                  .utc(auth.access_control_end_time)
                  .format('DD/MM/YYYY HH:mm')
              : '',
          })
        })
      })

      return result
    },
  },
  watch: {
    async dialogCheckPermissions(value) {
      if (value) {
        await this.getAuthorityEmployeeInAuthority()
      }
    },
    optionsEmployee: {
      async handler() {
        await this.getAuthorityEmployeeInAuthority()
      },
      deep: true,
    },
  },
  async created() {
    try {
      const { company_uuid } = this.$store.state.authentication.company

      this.loadingFilterOrganization = true

      const payload = {
        company_uuid,
        params: {
          dpc: 'access-authority-summary-to-list-organization',
        },
      }

      await this.fetchOrganizations(payload)
    } catch (error) {
      const snackbar = {
        show: true,
        color: 'error',
        timeout: -1,
        message: error?.response?.data?.message || 'Something went wrong!',
      }
      this.$store.commit('SET_SNACKBAR', snackbar)
    } finally {
      this.loadingFilterOrganization = false
    }
  },
  methods: {
    ...mapActions({
      fetchAuthorityEmployeeInAuthority:
        'accessAuthority/fetchAuthorityEmployeeInAuthority',
      fetchOrganizations: 'organization/fetchOrganizations',
      deleteAuthorityEmployeeMember:
        'accessAuthority/deleteAuthorityEmployeeMember',
      fetchAccessAuthority: 'accessAuthority/fetchAccessAuthority',
    }),
    onShowEmployeeStatus(employee) {
      this.selectedEmployeeStatus = employee
      this.employeeStatusDialog = true
    },
    formatDateTime(value) {
      if (!value) {
        return '-'
      }

      const date = moment(value)
      return date.isValid() ? date.format('DD/MM/YYYY HH:mm') : '-'
    },
    getEmployeeSyncBlockReason(employee) {
      const resignDate = employee?.resign_date
      if (resignDate) {
        return 'ลาออก'
      }

      if (employee?.is_active === false || employee?.is_active === 0) {
        return 'ปิดการใช้งาน'
      }

      if (employee?.is_blacklist === true || employee?.is_blacklist === 1) {
        return 'ติด blacklist'
      }

      const startAt = employee?.time_attendance_start_time
      if (startAt) {
        const startMoment = moment(startAt)
        if (startMoment.isValid() && moment().isBefore(startMoment)) {
          return `ยังไม่อนุญาตการใช้งาน วันที่ ${startMoment.format(
            'DD/MM/YYYY HH:mm'
          )}`
        }
      }

      const endAt = employee?.time_attendance_end_time
      if (endAt) {
        const endMoment = moment(endAt)
        if (endMoment.isValid() && moment().isAfter(endMoment)) {
          return `หมดอายุการใช้งาน วันที่ ${endMoment.format(
            'DD/MM/YYYY HH:mm'
          )}`
        }
      }

      return null
    },
    onDeleteEmployee(item) {
      this.confirmDeleteEmployee = true
      this.confirmDeleteEmployeeData = {
        title: 'ยืนยันการลบ',
        text: `คุณต้องการลบพนักงาน`,
        value: `${item.employeeCode} - ${item.employeeName} จากกลุ่ม ${item.authority}`,
        item: { data: { ...item } },
      }
    },
    cancelConfirmDeleteEmployee() {
      this.confirmDeleteEmployee = false
    },
    async submitConfirmDeleteEmployee({ data }) {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.confirmDeleteEmployeeLoading = true

        await this.deleteAuthorityEmployeeMember({
          company_uuid,
          authority_uuid: data.authority_uuid,
          body: {
            employee_uuid: data.employee_uuid,
          },
        })

        const accessAuthority = await this.fetchAccessAuthority({
          company_uuid,
          authority_uuid: data.authority_uuid,
        })

        this.$store.commit(
          'accessAuthority/EDIT_ACCESS_AUTHORITY',
          accessAuthority
        )

        this.optionsEmployee.page = 1
        this.getAuthorityEmployeeInAuthority()

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 4000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        console.log(error)
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.confirmDeleteEmployeeLoading = false
        this.confirmDeleteEmployee = false
      }
    },
    handleRefresh() {
      this.optionsEmployee.page = 1
      this.getAuthorityEmployeeInAuthority()
    },
    handleSearch() {
      this.loading = true
      this.getAuthorityEmployeeInAuthorityBySearch()
    },
    handleFilterOrganization() {
      this.optionsEmployee.page = 1
      this.getAuthorityEmployeeInAuthority()
    },
    getAuthorityEmployeeInAuthorityBySearch: _.debounce(function () {
      this.optionsEmployee.page = 1
      this.getAuthorityEmployeeInAuthority()
    }, 1000),
    async getAuthorityEmployeeInAuthority() {
      try {
        this.loading = true

        const { sortBy, sortDesc, page, itemsPerPage } = this.optionsEmployee

        let sort = ''
        const sortByKey = sortBy[0] || ''

        const SORT_MAPPING = {
          employeeCode: 'employee_code',
        }

        sort = SORT_MAPPING[sortByKey] || sortByKey

        if (sortDesc.length > 0) {
          if (sortDesc[0]) {
            sort += `,desc`
          } else {
            sort += `,asc`
          }
        }

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          params: {
            // dpc: '',
            search: this.search || undefined,
            organization_uuid: this.filterOrganization || undefined,
            sort,
            limit: `${itemsPerPage},${(page - 1) * itemsPerPage}`,
          },
        }

        await this.fetchAuthorityEmployeeInAuthority(payload)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loading = false
      }
    },
  },
  beforeDestroy() {
    if (this.getAuthorityEmployeeInAuthorityBySearch) {
      this.getAuthorityEmployeeInAuthorityBySearch.cancel()
    }
  },
}
</script>

<style scoped>
.with-borders >>> table,
.with-borders >>> th,
.with-borders >>> td {
  border: 1px solid #ccc;
  border-collapse: collapse;
}

.with-borders >>> th,
.with-borders >>> td {
  padding: 8px;
}
</style>
